import React, { Component } from 'react';
import Flatpickr from 'react-flatpickr'
//Checked
export default class View extends Component {
	constructor(props) {
		super(props)
		this.state = {
			CINerror: false,
			DOBerror: false,
			loading: false
		}
	}


	checkCIN(CIN) {
		if (CIN != undefined && CIN.length != 8) {
			this.setState({ CINerror: 'Invalid Entry' })
		} else if (!(/[a-zA-Z][a-zA-Z]\d\d\d\d\d[a-zA-Z]/gm.test(CIN))) {
			this.setState({ CINerror: 'Invalid Entry' })
		}
	}

	checkDOB(DOB) {
		console.log(DOB)
		if (new Date(DOB).getTime() >= new Date().getTime()) {
			this.setState({ DOBerror: 'Invalid Entry' })
		} else {
			this.setState({ DOBerror: null })
		}
	}



	navCheck() {
		if (((this.props.data.CallType == 'Request' || this.props.data.CallType == 'Cancel') && (this.props.data.DOB && this.props.data.CIN) && !this.state.DOBerror) || (this.props.data.CallType == 'Inquiry' && this.props.data.CIN) || (this.props.data.CallType == 'Dispense' && this.props.data.CIN)) {
			//Have the Stuff
			fetch(window.location.origin + window.location.pathname + 'CIN', { method: 'POST', headers: { "Content-Type": 'application/json' }, body: JSON.stringify({ data: this.props.data }) }).then(async (response) => {
				if (response.status == 200) {
					if (this.props.data.CallType == 'Inquiry') {
						fetch(window.location.origin + window.location.pathname + 'P2Check', { method: 'POST', headers: { "Content-Type": 'application/json' }, body: JSON.stringify({ data: this.props.data }) }).then(async (response) => {
							if (response.status == 200) {
								var result = await response.json()
								if (!result) {
									this.props.navigate('P1')
								} else {
									if (this.props.data["Participant Type"] == 'Prescriber') {
										console.log(result)
										if (result.PAList.length == 0) {
											this.props.navigate('P1')
										} else {
											this.props.data.TotalCaloriesPerDay = result.TotalCaloriesPerDay
											this.props.data.TotalCaloriesPerMonth = result.TotalCaloriesPerMonth
											this.props.data.PAList = result.PAList

											this.props.navigate('P2')
										}

									} else if (this.props.data["Participant Type"] == 'Dispenser') {
										if (!result.TotalCaloriesPerDay) {
											this.props.navigate('F2')
										} else {
											this.props.data.TotalCaloriesPerDay = result.TotalCaloriesPerDay
											this.props.data.TotalCaloriesPerMonth = result.TotalCaloriesPerMonth
											this.props.data.PAList = result.PAList

											this.props.navigate('F1')
										}
									}
								}
							} else {
								this.setState({ PACheckerror: await response.text() })
							}
						})
					} else if (this.props.data.CallType == 'Cancel') {
						this.props.navigate('B1')
					} else if (this.props.data.CallType == 'Request') {
						fetch(window.location.origin + window.location.pathname + 'checkforineligiblecin', { method: 'POST', headers: { "Content-Type": 'application/json' }, body: JSON.stringify({ data: this.props.data }) }).then(async (response) => {
							if (response.status == 200) {
								console.log(response);
								var result = await response.json()
								console.log(result);
								//Returns false if it wasnt not on the list, false continues true errors
								if (result) {//CIN is ineligible
									this.props.navigate('A3')
								} else {
									this.props.navigate('R1')
								}
							} else {
								this.setState({ PACheckerror: await response.text() })
							}
						})

					} else if (this.props.data.CallType == 'Dispense') {
						//D3 Check
						console.log("Yo")
						this.setState({ loading: true })
						fetch(window.location.origin + window.location.pathname + 'D3Check', { method: 'POST', headers: { "Content-Type": 'application/json' }, body: JSON.stringify({ data: this.props.data }) }).then(async (response) => {
							this.setState({ loading: false })
							var result
							if (response.status == 200) {
								result = await response.text();
								this.props.navigate(result);
							} else if (response.status == 225) {
								//JSON Returned
								//D4
								result = await response.json();
								this.props.data.CaloricUnits = result.CaloricUnits
								this.props.data.RefillsRequested = result.RefillsRequested
								this.props.data.ExpirationDate = result.ExpirationDate
								this.props.data.ModeOfAdmin = result.ModeOfAdmin
								this.props.data.PA = result.PA
								this.props.data.Enteral = result.Enteral
								this.props.navigate('D8');
							} else {
								this.setState({ PAError: 'Unexpected Error Occured.' })
							}
						})
					}
				} else {
					this.props.navigate('A2B')
				}
			})

		} else {
			/*
			if (this.props.data.CallType == 'Inquiry') {
				this.setState({ CINerror: 'Invalid Entry' })
			} else {
				if (!this.props.data.DOB) {
					this.setState({ DOBerror: 'Invalid Entry' })

				} else {
					this.setState({ CINerror: 'Invalid Entry' })

				}
			}
			*/
		}


	}

	render() {
		return (
			<div style={{ textAlign: 'left', overflowWrap: 'break-word' }}>
				<h3 style={{ textAlign: 'center' }}>Enter Client Info</h3>
				<hr />

				<p>Enter the member's client identification number.</p>
				<input type="text" value={this.props.data.CIN} onBlur={() => { this.checkCIN(this.props.data.CIN) }} onChange={(e) => { this.props.setData('CIN', e.currentTarget.value.toUpperCase()); this.setState({ CINerror: false }) }} />
				{this.state.CINerror ? <div className="error">{this.state.CINerror}</div> : ''}

				{this.props.data.CallType == 'Request' || this.props.data.CallType == 'Cancel' ?
					<div>
						<p>Enter the member's date of birth.</p>
						<Flatpickr data-allowInput="true" options={{
							allowInput: true, dateFormat: "m/d/Y", altFormat: "ddmmyyyy", parseDate: (datestr, format) => {
								//add / to datestr if needed
								if (datestr.length == 8) {
									datestr = datestr.slice(0, 2) + '/' + datestr.slice(2, 4) + '/' + datestr.slice(4, 8)
								}
								return new Date(datestr)
							}, defaultHour: 0, defaultMinute: 0
						}} value={this.props.data.DOB ? this.props.data.DOB : null} onChange={(value) => { this.props.setData('DOB', value); this.checkDOB(this.props.data.DOB) }} />
						{this.state.DOBerror ? <div className="error">{this.state.DOBerror}</div> : ''}
					</div>
					: ''}

				{this.state.PACheckerror ? <div className="error">{this.state.PACheckerror}</div> : ''}
				{this.state.loading ? <div className="loader"></div> : <div className="button" style={((this.props.data.CallType == 'Request' || this.props.data.CallType == 'Cancel') && (this.props.data.DOB && this.props.data.CIN)) || (this.props.data.CallType == 'Inquiry' && this.props.data.CIN) || (this.props.data.CallType == 'Dispense' && this.props.data.CIN) ? {} : { backgroundColor: '#888' }} onClick={() => { this.navCheck() }}>Continue</div>}
			</div>
		);

	}
}